import React, { createRef, ReactNode, useEffect, useRef, useState } from "react";
import { isReactNodeEmpty } from "../../utils/objectUtils";

interface MobilePieceInfoGroupsInnerProps {
    children: ReactNode;
    updateHeight: (newHeight: number) => void;
    active: number;
    id: number;
    swipeOffset: number;
    setSwipeOffset: (newOffset: number) => void;
    easeOutSwipe: () => void;
    minHeight: number;
    empty?: boolean;
}

export default function MobilePieceInfoGroupsInner(props: MobilePieceInfoGroupsInnerProps) {

    const mouseX = useRef(0);

    const ref = createRef<HTMLDivElement>();
    useEffect(() => {
        checkHeight();
        window.addEventListener("resize", checkHeight);
        ref.current?.addEventListener("mousedown", dragMouseDown);
        return () => {
            window.removeEventListener("resize", checkHeight);
        }
    });
    function checkHeight() {
        if(ref.current) {
            props.updateHeight(ref.current.clientHeight);
        }
    }

    function dragMouseDown(e: MouseEvent) {
        e = e || window.event;
        e.preventDefault();
        document.onmouseup = closeDragElement;
        document.onmousemove = elementDrag;
        mouseX.current = e.clientX;
    }

    function elementDrag(e: MouseEvent) {
        e = e || window.event;
        e.preventDefault();
        props.setSwipeOffset(props.swipeOffset + (e.clientX - mouseX.current));
    }

    function closeDragElement() {
        document.onmouseup = null;
        document.onmousemove = null;
        props.setSwipeOffset(0);
    }

    console.log(props.children, React.Children.count(props.children))

    return (
        <div ref={ref} className="mobile-piece-info-group-inner" style={{
            left: "calc(100% * " + (props.id - props.active) + ")",
            marginLeft: props.swipeOffset + "px",
            minHeight: props.minHeight + "px",
        }}>
            {props.empty && <p className="quotation">No Information available</p>}
            {props.children}
        </div>
    );
}